import { CircularProgress, Link, Tooltip } from '@material-ui/core';
import React, { memo } from 'react';
import { usePickerHelper } from "./picker-helper.hook.js";
const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  rowGap: '10px',
  paddingTop: '15px',
  width: '240px',
  paddingInline: '10px'
};
export const PickerHelper = ({
  handleJumpToCurrentPath,
  contextPath,
  styles,
  currentContentText,
  selectionRoots,
  repository
}) => {
  const {
    helperPaths,
    isAncestorOfRoot,
    isLoading
  } = usePickerHelper({
    contextPath,
    selectionRoots,
    repository
  });
  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", {
      style: containerStyle
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      color: "primary"
    }));
  }
  if (!isAncestorOfRoot && helperPaths.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    style: containerStyle
  }, isAncestorOfRoot && contextPath && /*#__PURE__*/React.createElement(Tooltip, {
    title: contextPath
  }, /*#__PURE__*/React.createElement(Link, {
    "data-test": "current-content",
    variant: "body2",
    onClick: () => handleJumpToCurrentPath(contextPath),
    className: styles
  }, currentContentText || 'Current Content')), helperPaths.length > 0 && /*#__PURE__*/React.createElement("div", {
    "data-test": "path-helpers"
  }, helperPaths.map(path => {
    return /*#__PURE__*/React.createElement(Tooltip, {
      key: path.Path,
      title: path.Path
    }, /*#__PURE__*/React.createElement(Link, {
      "data-test": `path-helper-${path.Path}`,
      variant: "body2",
      onClick: () => handleJumpToCurrentPath(path.Path),
      className: styles
    }, path.DisplayName || path.Name));
  })));
};
export default /*#__PURE__*/memo(PickerHelper, (prevProps, nextProps) => prevProps.contextPath === nextProps.contextPath);
//# sourceMappingURL=picker-helper.js.map